import React from 'react'

const milestoneData = [
   {
      year: '2024',
      title: 'Present',
      position: 'right',
      className: 'circle-vector',
      points: [
         'Focused on further innovation with AI-driven applications and cloud services.',
         'Continuing to scale globally with strong client relationships.',
         'Investing in the latest technologies to offer cutting-edge solutions.',
      ],
   },
   {
      year: '2023',
      title: '10-Year Milestone',
      position: 'left',
      className: 'tri-vector',
      points: [
         'Celebrated a decade of innovation and excellence.',
         'Expanded workforce and client base.',
         'Committed to sustainability and corporate responsibility.',
      ],
   },
   {
      year: '2022',
      title: 'Industry Recognition',
      position: 'right',
      className: 'tri-vector-2',
      points: [
         'Recognized as a leading IT solutions provider in various sectors.',
         'Awarded for delivering high-impact software solutions.',
      ],
   },
   {
      year: '2021',
      title: 'AI and Automation Focus',
      position: 'left',
      className: '',
      points: [
         'Enhanced AI-powered solutions for intelligent automation.',
         'Invested in upskilling employees on AI, machine learning, and blockchain technologies.',
      ],
   },
   {
      year: '2020',
      title: 'Resilience and Digital Transformation',
      position: 'right',
      className: '',
      points: [
         'Successfully navigated the challenges of the COVID-19 pandemic with remote operations.',
         'Assisted clients in accelerating their digital transformation.',
      ],
   },
   {
      year: '2019',
      title: 'Innovation and Product Development',
      position: 'left',
      className: '',
      points: [
         'Launched proprietary SaaS products targeting industry-specific needs.',
         'Strengthened R&D efforts to drive innovation.',
      ],
   },
   {
      year: '2018',
      title: 'Global Expansion',
      position: 'right',
      className: '',
      points: [
         'Expanded operations to serve foreign clients across multiple regions.',
         'Formed strategic partnerships to enhance service delivery.',
      ],
   },
   {
      year: '2017',
      title: 'Operational Excellence',
      position: 'left',
      className: '',
      points: [
         'Adopted Agile development methodologies for faster project delivery.',
         'Achieved significant milestones in project management and customer satisfaction.',
      ],
   },
   {
      year: '2016',
      title: 'Embracing New Technologies',
      position: 'right',
      className: '',
      points: [
         'Integrated AI/ML and data analytics into service offerings.',
         'Developed industry-specific solutions, including FinTech and HealthTech applications.',
      ],
   },
   {
      year: '2015',
      title: 'Diversification and Service Expansion',
      position: 'left',
      className: '',
      points: [
         'Diversified into e-commerce development and cloud-based solutions.',
         'Partnered with international clients, expanding market presence.',
      ],
   },
   {
      year: '2014',
      title: 'Early Growth and Expansion',
      position: 'right',
      className: '',
      points: [
         'Expanded team size and established a development center.',
         'Acquired first set of long-term clients.',
         'Launched initial projects in web applications and mobile app development.',
      ],
   },
   {
      year: '2013',
      title: 'Establishment and Foundation',
      position: 'left',
      className: 'mb-0',
      points: [
         'Company founded in January 2013 with a vision to deliver innovative IT solutions.',
         'Initial focus on providing custom software development and web development services.',
      ],
   },
]

function Milestones() {
   return (
      <section className="cs-bg-secondary pb-0 pt-5">
         <div className="container pt-md-5 pt-0">
            <p className="milestone_title">Milestones</p>
            <p className="section_heading_title mb-3 tech_title">
               How It All Began
            </p>
            <p className="section_desc mb-5 core-value-sub">
               Success is a blend of opportunity and relentless effort. Our
               journey started with a team of seasoned professionals, each
               bringing experience from leading global corporations. Through
               dedication and expertise, we transformed our vision into
               reality—laying the foundation for what Benzatine Infotech is
               today.
            </p>
         </div>

         <div className="milestone_roadmap">
            <div className="text-center justify-content-center top_container">
               <h3 className="feature_card_title pt-5">
                  Moving Forward to Our Vision
               </h3>
               <p className="start_point">2025</p>
            </div>

            <div className="timeline">
               <div className="containr left-container"></div>
               {milestoneData.map((milestone, index) => (
                  <div
                     key={index}
                     className={`containr ${milestone.position}-container ${milestone.className}`}
                  >
                     <img
                        src={`/assets/svg/discover/arrow-${milestone.position}.svg`}
                        alt={`${milestone.position} arrow`}
                     />
                     <div
                        className={`text-box ${
                           milestone.position === 'left' ? 'even' : ''
                        }`}
                     >
                        <h2 className="road_title">
                           {milestone.title}: {milestone.year}
                        </h2>
                        <ul className="road_desc">
                           {milestone.points.map((point, idx) => (
                              <li key={idx}>{point}</li>
                           ))}
                        </ul>
                     </div>
                  </div>
               ))}
            </div>

            <div className="text-center justify-content-center end_point_section">
               <p className="start_point end_point">
                  <svg
                     width="27"
                     height="27"
                     viewBox="0 0 27 27"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <circle
                        cx="13.9492"
                        cy="13.6162"
                        r="12.5"
                        fill="#F1ECDC"
                        stroke="#1F473E"
                     />
                     <circle cx="13.9492" cy="13.6162" r="8" fill="#1F473E" />
                  </svg>
               </p>
               <h3 className="feature_card_title end_title pt-5 mb-0 pb-5">
                  Born of Benzatine Infotech
               </h3>
            </div>
         </div>
      </section>
   )
}

export default Milestones
